module.exports = __webpack_public_path__ + "static/img/banner.f82b5c4b.png";